import { type CsvProductSnapshot } from '../../../hooks/use-stm-quick-order-store'

/** display_name 是各品牌手動維護的變體標題（帶 SKU、格式不一），不拿來顯示；用母商品名稱加規格組標題 */
export const formatCsvItemTitle = (product: CsvProductSnapshot): string =>
  product.specName ? `${product.parentProductName}｜${product.specName}` : product.parentProductName
